import PropTypes from 'prop-types';
import { compose, withProps, getDisplayName, getContext, setDisplayName } from 'recompose';
var withStyleSheetOverrideFromContext = Target => compose(setDisplayName('WithStyleSheetOverrideFromContext'), compose(getContext({
  getStyleSheet: PropTypes.object
}), withProps(_ref => {
  var {
    getStyleSheet
  } = _ref;
  return {
    getStyleSheet: getStyleSheet ? getStyleSheet[getDisplayName(Target)] : () => ({})
  };
})))(Target);
export default withStyleSheetOverrideFromContext;
//# sourceMappingURL=index.js.map